import CheckBoxTable from './CheckBoxTable';

export default CheckBoxTable;